import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { voiceAgentService } from "@/services/voiceAgentService";

export function useArchiveVoiceAgent() {
  const [isArchiving, setIsArchiving] = useState(false);
  const { organization } = useAuth();
  const { toast } = useToast();

  const archive = async (agentId: string) => {
    if (isArchiving) return false;

    if (!organization?.id) {
      toast({
        variant: "destructive",
        title: "Organization required",
        description: "No organization found for archiving voice agent",
      });
      return false;
    }

    setIsArchiving(true);
    try {
      const { error } = await voiceAgentService.archiveVoiceAgent(agentId);

      if (error) {
        throw error;
      }

      toast({
        title: "Voice agent archived",
        description: "The voice agent has been archived successfully",
      });

      return true;
    } catch (error: any) {
      console.error("Error archiving voice agent:", error);
      toast({
        variant: "destructive",
        title: "Error archiving voice agent",
        description: error.message || "An unexpected error occurred",
      });
      return false;
    } finally {
      setIsArchiving(false);
    }
  };

  return { archive, isArchiving };
}
